// Audio context singleton to handle browser audio API
let audioContext: AudioContext | null = null;

// Initialize audio context on first user interaction
export function initAudioContext() {
  if (!audioContext) {
    audioContext = new AudioContext();
  }
  return audioContext;
}

// Generate a short beep sound
async function generateBeep(frequency: number = 440, duration: number = 0.15): Promise<AudioBuffer> {
  const ctx = initAudioContext();
  const sampleRate = ctx.sampleRate;
  const samples = duration * sampleRate;
  const buffer = ctx.createBuffer(1, samples, sampleRate);
  const data = buffer.getChannelData(0);

  for (let i = 0; i < samples; i++) {
    // Create a decaying sine wave
    const t = i / sampleRate;
    const decay = 1 - t / duration;
    data[i] = Math.sin(2 * Math.PI * frequency * t) * decay;
  }

  return buffer;
}

// Play the alert sound
export async function playAlertSound() {
  try {
    const ctx = initAudioContext();
    
    // Create two beeps with different frequencies
    const beep1 = await generateBeep(880, 0.15); // Higher pitch
    const beep2 = await generateBeep(660, 0.15); // Lower pitch

    // Play the beeps in sequence
    const source1 = ctx.createBufferSource();
    const source2 = ctx.createBufferSource();
    
    source1.buffer = beep1;
    source2.buffer = beep2;

    // Add a gain node to control volume
    const gainNode = ctx.createGain();
    gainNode.gain.value = 0.2; // Reduce volume to 20%

    source1.connect(gainNode);
    source2.connect(gainNode);
    gainNode.connect(ctx.destination);

    // Schedule the beeps
    source1.start(ctx.currentTime);
    source2.start(ctx.currentTime + 0.2); // Play second beep after 200ms
  } catch {
    return;
  }
} 